import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: "Resets",
  initialState,
  reducers: {
    requestStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    Success: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    Failure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.data = null;
    },
  },
});

export const { requestStart, Success, Failure } = authSlice.actions;
export default authSlice.reducer;

export const sendResetLink = (data, navigate) => async (dispatch) => {
  try {
    dispatch(requestStart());

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/public/reset`,
      data
    );

    if (response?.status === 200) {
      dispatch(Success(response.data));
      toast.success("Please Check your Email.");
    }
  } catch (err) {
    toast.error(err?.response?.data?.message || "failed!");
    dispatch(Failure(err?.response?.data?.message || "Something went wrong!"));
  }
};

export const updatePassword = (data, navigate) => async (dispatch) => {
  try {
    dispatch(requestStart());

    const response = await axios.put(
      `${process.env.REACT_APP_API_URL}/public/reset`,
      data
    );

    if (response?.status === 201) {
      dispatch(Success(response.data));
      toast.success("successfully Password Changed!");
    }
  } catch (err) {
    toast.error(err?.response?.data?.message || "failed!");
    dispatch(Failure(err?.response?.data?.message || "Something went wrong!"));
  }
};
